const setFristChildrenCountry = (id = null, val = null) => {
  return {
    type: 'SET_FRISTCHILDRENCOUNTRY',
    id,
    data: val,
  }
}

export default {
  setFristChildrenCountry,
}